import { Injectable } from '@angular/core';
import { QuotationCommercialItem } from 'projects/dop-ordering/src/lib/models/quotable-items/quotation-commercial-item.model';
import { CommercialItemValidationResponse } from '../../models/commercial-item-validation-response.model';

@Injectable({
    providedIn: 'root'
})
export class CustomerPackagePlanningLineRule {

    constructor(private quotationCommercialItem: QuotationCommercialItem) { }

    isCPApplicable(subgroupCode: string): CommercialItemValidationResponse {
        let isValid = true;
        isValid = this.quotationCommercialItem?.customerPackages?.some(c => c.code === subgroupCode);
        return {
            isValid,
        };
    }

}
